import { render, staticRenderFns } from "./EditList.vue?vue&type=template&id=0f23fca5&"
import script from "./EditList.vue?vue&type=script&lang=js&"
export * from "./EditList.vue?vue&type=script&lang=js&"
import style0 from "./EditList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports